import { render, staticRenderFns } from "./CommentsList.vue?vue&type=template&id=4b03fabf&scoped=true"
import script from "./CommentsList.vue?vue&type=script&lang=ts"
export * from "./CommentsList.vue?vue&type=script&lang=ts"
import style0 from "./CommentsList.vue?vue&type=style&index=0&id=4b03fabf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b03fabf",
  null
  
)

export default component.exports